import React from 'react';

const IconMovie = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 9.28809C4.25 8.4593 4.92121 7.78809 5.75 7.78809H13.625C14.4538 7.78809 15.125 8.4593 15.125 9.28809V11.6911C15.125 11.6914 15.125 11.6917 15.125 11.692V13.8841C15.125 13.8844 15.125 13.8847 15.125 13.885V16.2881C15.125 17.1169 14.4538 17.7881 13.625 17.7881H5.75C4.92121 17.7881 4.25 17.1169 4.25 16.2881V9.28809ZM16.625 15.4513V16.2881C16.625 17.9453 15.2822 19.2881 13.625 19.2881H5.75C4.09279 19.2881 2.75 17.9453 2.75 16.2881V9.28809C2.75 7.63087 4.09279 6.28809 5.75 6.28809H13.625C15.2822 6.28809 16.625 7.63087 16.625 9.28809V10.1248L19.1998 8.05277C20.4269 7.06452 22.25 7.9387 22.25 9.51307V16.0631C22.25 17.6376 20.4266 18.5118 19.1995 17.5231L16.625 15.4513ZM16.625 13.5259L20.1402 16.3548C20.3851 16.5521 20.75 16.3785 20.75 16.0631V9.51307C20.75 9.19758 20.3855 9.02377 20.1406 9.22109L16.625 12.0502V13.5259Z"
        fill="#8594A3"
      />
    </svg>
  );
};

export default IconMovie;
